<template>
    <div class="business-content-main add-accessories" v-loading="loading">
        <div class="bread-nav">
            <breadcrumb :canBackHistory="true" :pageTitle="pageTitle"></breadcrumb>
        </div>
        <div class="section">
            <div class="all">
                <div class="btns">
                    <el-button size="small" class="search-btn" type="warning" icon="el-icon-upload" :disabled="saveBtndisabled" @click="submitConfirm"
                        >提交保存</el-button
                    >
                </div>
                <div class="form-main">
                    <el-form :rules="rules" :model="partData" ref="partData" label-width="80px" class="form-ctn">
                        <div class="form-main">
                            <div class="form-line">
                                <div class="form-item">
                                    <el-form-item label="汽配名称" prop="GoodName">
                                        <el-autocomplete
                                            class="search-item"
                                            size="medium"
                                            v-model="partData.GoodName"
                                            :fetch-suggestions="searchGoodName"
                                            :debounce="500"
                                            placeholder="请输入配件名称"
                                            :trigger-on-focus="false"
                                        ></el-autocomplete>
                                    </el-form-item>
                                </div>
                                <div class="form-item">
                                    <el-form-item label="英文名称" prop="ExAttribute4">
                                        <el-input v-model="partData.ExAttribute4" class="search-item" size="medium"></el-input>
                                    </el-form-item>
                                </div>
                                <div class="form-item">
                                    <el-form-item label="英文车型">
                                        <el-input v-model="partData.ExAttribute6" class="search-item" size="medium"></el-input>
                                    </el-form-item>
                                </div>
                                <div class="form-item">
                                    <el-form-item label="适用车型"  prop="AutoSerise">
                                        <el-autocomplete
                                            class="search-item"
                                            size="medium"
                                            :debounce="500"
                                            v-model="partData.AutoSerise"
                                            :fetch-suggestions="searchAutoSerise"
                                            placeholder="请输入车型"
                                            :trigger-on-focus="false"
                                            @change="getWatermarkText()"
                                        ></el-autocomplete>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="form-line">
                                <div class="form-item">
                                    <el-form-item label="汽配编码" prop="APCode">
                                        <div style="width: 200px; display: flex; flex-direction: column; align-content: center; text-align: center">
                                            <el-input class="search-item" size="medium" v-model="partData.APCode" @change="getAutoSeriesByApCode"></el-input>
                                            <!-- <span class="invTip">为了更好地进行车型匹配，请用原厂编码</span> -->
                                        </div>
                                    </el-form-item>
                                </div>
                                <div class="form-item price-point">
                                    <el-form-item label="汽配分类" prop="ExAttribute1">
                                        <el-select
                                            class="cate-select search-item"
                                            v-model="partData.ExAttribute1"
                                            filterable
                                            clearable
                                            remote
                                            reserve-keyword
                                            allow-create
                                            size="small"
                                            :remote-method="searchCate"
                                            v-select-scroll-more="searchCateLoad"
                                            @visible-change="cateVisibleChange($event)"
                                            @clear="cateClearHandle"
                                            placeholder="请输入汽配分类"
                                        >
                                            <el-option v-for="optionItem in apCategoryList" :key="optionItem.Value" :label="optionItem.Text" :value="optionItem.Value">
                                                <div class="option-content">
                                                    <div>{{ optionItem.Text }}</div>
                                                </div>
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                                <div class="form-item">
                                    <el-form-item label="配件尺寸" prop="Size">
                                        <el-input v-model="partData.Size" class="search-item" size="medium"></el-input>
                                    </el-form-item>
                                </div>
                                <div class="form-item">
                                    <el-form-item label="重量" prop="Quality">
                                        <el-input type="number" step="0.01" v-model="partData.Quality" class="search-item" size="medium" :min="0">
                                            <template slot="append">kg</template>
                                        </el-input>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="form-line">
                                <div class="form-item price-point">
                                    <el-form-item label="单位" prop="Unit">
                                        <el-autocomplete
                                            style="width: 200px"
                                            clearable
                                            popper-class="autocomplete"
                                            v-model.trim="partData.Unit"
                                            :fetch-suggestions="searchUnit"
                                            value-key="Value"
                                            size="medium"
                                        ></el-autocomplete>
                                    </el-form-item>
                                </div>
                                <div class="form-item">
                                    <el-form-item label="材质" prop="Texture">
                                        <el-input
                                            class="search-item"
                                            size="medium"
                                            v-model="partData.Texture"
                                        ></el-input>
                                    </el-form-item>
                                </div>
                                <div class="form-item" style="width: 40.66%">
                                    <el-form-item label="包装尺寸" class="packageSize" prop="PackageSize">
                                        长
                                        <input
                                            v-model.number="partData.Length"
                                            type="number"
                                            min="0"
                                            size="small"
                                            @blur="inputBlur"
                                            @focus="inputFocus"
                                        />
                                        &nbsp;宽
                                        <input
                                            v-model.number="partData.Width"
                                            type="number"
                                            min="0"
                                            size="small"
                                            @blur="inputBlur"
                                            @focus="inputFocus"
                                        />
                                        &nbsp;高
                                        <input
                                            v-model.number="partData.Height"
                                            type="number"
                                            min="0"
                                            size="small"
                                            @blur="inputBlur"
                                            @focus="inputFocus"
                                        />
                                        (cm)
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="form-line">
                                <div class="form-item" style="width: 30%">
                                    <el-form-item label="主要图片">
                                        <uploadFile
                                            ref="uploadMainFile"
                                            type="EntpTempGoods"
                                            :limit="1"
                                            :initfileList="partData.MainImg ? [partData.MainImg] : []"
                                            @uploadSuccess="uploadMainSuccess"
                                            @handleRemove="handleMainRemove"
                                            :wText="watermarkText"
                                            viewName="ecGoods"
                                        ></uploadFile>
                                    </el-form-item>
                                </div>
                                <div class="form-item" style="width: 65%">
                                    <el-form-item label="辅助图片">
                                        <uploadFile
                                            ref="uploadMinorFile"
                                            type="EntpTempGoods"
                                            :multiple="true"
                                            :initfileList="uploadPictureList"
                                            @uploadSuccess="uploadMinorSuccess"
                                            @handleRemove="handleMinorRemove"
                                            viewName="ecGoods"
                                        ></uploadFile>
                                    </el-form-item>
                                </div>
                            </div>
                        </div>
                    </el-form>
                </div>
            </div>
            <!-- <div class="middle" style="height: 600px">
                <div class="title">
                    汽配互换码
                </div>
                <el-input
                    class="input-textarea"
                    type="textarea"
                    placeholder="输入请用回车隔行分开，如复制粘贴进来的格式必须带（半角 ',' 或全角逗号 '，'）才会自动转化成标准的回车格式"
                    v-model="enterGoodCode"
                    @paste.native.capture.prevent="handlePaste"
                    @change="getWatermarkText()"
                ></el-input>
            </div> -->
        </div>
    </div>
</template>
<script>
import breadcrumb from '@/components/common/breadcrumb';
import uploadFile from '@/components/common/uploadBtn';
export default {
    components: {
        breadcrumb,
        uploadFile
    },
    data() {
        let checkAPCode = (rule, value, callback) => {
            if (!this.partData.EntpTempGoodsId) {
                this.checkAPCode()
                    .then(() => {
                        return callback(new Error('已存在相同的商品'));
                    })
                    .catch(() => {
                        callback();
                    });
            } else {
                callback();
            }
        };
        return {
            pageTitle: '',
            needConfirm: true,
            saveBtndisabled: false, //保存按钮是否禁用
            storeVisible: false,
            isCheckCode: true,
            partData: {
                EntpTempGoodsId: '',
                GoodName: '',
                GoodCode: '',
                MainImg: '',
                APId: '',
                APCode: '',
                Size: '',
                Quality: '',
                Brand: '',
                Unit: '',
                ExAttribute1: '',
                ExAttribute4: '',
                ExAttribute6: '',
                AutoSerise: '',
                PackageSize: '',
                PackingNum: '',
                PictureList: [],
                Texture:'',
                Length: 0,
                Width: 0,
                Height: 0,
                GoodsSeriesRs:[],
                AllModels:false,
            },
            enterGoodCode: '',
            loading: false,
            uploadPictureList: [],
            brandList: [],
            unitList: [],
            apCategoryList: [],
            cateForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            rules: {
                APCode: [
                    { required: true, message: '该项必填', trigger: 'blur' },
                    { validator: checkAPCode, trigger: 'blur' }
                ],
                APId: [{ required: true, message: '该项必填', trigger: 'change' }],
                GoodName: [{ required: true, message: '该项必填', trigger: 'blur' }],
                Brand: [{ required: true, message: '该项必填', trigger: 'change' }],
                PictureList: [{ required: true, message: '该项必填', trigger: 'blur' }],
                Quality: [{ required: true, message: '该项必填', trigger: 'blur' }],
                Unit: [{ required: true, message: '该项必填', trigger: 'change' }],
                ExAttribute1: [{ required: true, message: '该项必填', trigger: 'change' }],
                AutoSerise: [{ required: true, message: '该项必填', trigger: 'change' }],
                PackageSize: [{ required: true,
                    validator: (rule, value, callback) => {
                        if (!this.partData.Length || !this.partData.Width || !this.partData.Height) {
                            callback(new Error('包装尺寸（长、宽、高）为必填项'));
                        } else {
                            callback(); // 验证通过
                        }
                    }
                    ,trigger: 'blur'}]
            },
            invenCanNotBeEdit: true,
            // 页面内容最小高度
            boxMinHeight: 'auto',
            goodNameOptions: [],
            autoSeriseOptions: [],
            autoSeriseForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            sptpsy: false, //商品图片添加水印
            watermarkText: '', //水印内容
            // 弹框车型已选项
            dialogCheckList: [],
            // 智能车型已选项
            brainCheckList: [],
            // 智能车型-当前下拉框选中项 string BrandId
            checkedSelect: '',
            // 智能车型-下拉框列表 Array
            checkSelectOptions: [],
            // 智能车型-当前展示的列表 Array
            checkCurrentOptions: [],
            // 智能车型-将接口返回的数据缓存这里 Array
            checkAllOptions: [],
            // 智能车型-当前展示列表的已选项 Array
            checkedCurrentList: [],
            // 智能车型-所有列表的已选项-以BrandId为键名 Object
            checkedAllList: {},
            // 车型弹框显隐
            dialogVisible: false,
        };
    },
    computed: {
        carTypeNoData() {
            return !this.checkCurrentOptions || this.checkCurrentOptions.length === 0;
        },
    },
    created() {
        document.addEventListener('keydown', this.handleKeyEvent);
    },
    mounted() {
        let id = this.$route.query.EntpTempGoodsId;
        this.partData.EntpTempGoodsId = id;
        if (id) {
            this.pageTitle = '编辑配件信息';
            this.getConfigByCodes().then(() => {
                this.getEnterprisePart();
            });
        } else {
            this.getConfigByCodes();
        }
    },
    beforeRouteLeave(to, from, next) {
        this.$util.confirmBeforeLeave(to, from, next, this);
    },
    methods: {
        handleKeyEvent(e) {
            let key = window.event.keyCode;
            let that = this;
            if (that.$refs.selectSearise) {
                if (that.$refs.selectSearise.checkSearchVisible()) {
                    if (that.$refs.selectSearise.$refs.searchSearise) {
                        //下键
                        if (key == 40) {
                            that.$refs.selectSearise.$refs.searchSearise.keyDownFunc();
                        }
                        //右键
                        if (key == 39) {
                            that.$refs.selectSearise.$refs.searchSearise.keyRightFunc();
                        }
                        //上键
                        if (key == 38) {
                            that.$refs.selectSearise.$refs.searchSearise.keyUpFunc();
                        }
                        //上键
                        if (key == 37) {
                            that.$refs.selectSearise.$refs.searchSearise.keyLeftFunc();
                        }
                        // + 键
                        if (key === 107) {
                            that.$refs.selectSearise.$refs.searchSearise.keyEnterFunc();
                        }
                        //esc
                        if (key === 27) {
                            that.$refs.selectSearise.closeSearchDialog();
                        }
                        //enter键
                        if (key === 13) {
                            that.$refs.selectSearise.$refs.searchSearise.chooseModels();
                        }
                    }
                } else {
                    //esc
                    if (key === 27) {
                        that.dialogVisible = false;
                    }
                    //enter键
                    if (key === 13) {
                        that.$refs.selectSearise.confirmButton();
                    }
                }
            }
        },
        getConfigByCodes() {
            return new Promise(resolve => {
                let codes = [
                    'sptpsy',
                    'xzqpbmdwyx',
                    'bkbjkcs'
                ];
                this.$util.getSysConfigs(codes).then(data => {
                    if (data) {
                        for (let i = 0; i < data.length; i++) {
                            let code = data[i].Code;
                            let result = data[i].Result;
                            let rValue = data[i].RValue;
                            switch (code) {
                                case 'sptpsy':
                                    this.sptpsy = result;
                                    break;
                                case 'xzqpbmdwyx': //是否检测编码重复
                                    this.isCheckCode = result;
                                    break;
                                case 'bkbjkcs': //库存数是否允许修改
                                    this.invenCanNotBeEdit = result;
                                    break;
                            }
                        }
                    }
                    resolve();
                });
            });
        },
        //获取库存商品信息
        getEnterprisePart() {
            let that = this;
            that.loading = true;
            that.$util
                .axiosGet({
                    url: '/api/EntpGoods/GetEnterprisePart',
                    data: {
                        EntpTempGoodsId: that.partData.EntpTempGoodsId
                    },
                    hideLoading: true
                })
                .then(res => {
                    if (res.data) {
                        let data = res.data;
                        if (data.PackageSize) {
                            let packageSize = data.PackageSize.split('*');
                            if (packageSize) {
                                data.Length = packageSize[0];
                                data.Width = packageSize[1];
                                data.Height = packageSize[2];
                            }
                        }

                        that.partData = {
                            EntpTempGoodsId: that.partData.EntpTempGoodsId,
                            GoodCode: data.GoodCode,
                            GoodName: data.GoodName,
                            MainImg: data.MainImg,
                            APCode: data.APCode,
                            Size: data.Size,
                            Quality: data.Quality,
                            Brand: data.Brand,
                            Unit: data.Unit,
                            ExAttribute1: data.ExAttribute1,
                            ExAttribute4: data.ExAttribute4,
                            ExAttribute6: data.ExAttribute6,
                            AutoSerise: data.AutoSerise,
                            PackageSize: data.PackingSize,
                            PackingNum: data.PackingNum,
                            PictureList: [],
                            Texture:data.Texture,
                            Length: data.Length,
                            Width: data.Width,
                            Height: data.Height,
                            AllModels:false,
                            GoodsSeriesRs:[]
                        };

                        let code = data.GoodCode;
                        if (code.indexOf(',') !== -1 || code.indexOf('，') !== -1) {
                            code = data.GoodCode.split(',').join('\n');
                            code = code.split('，').join('\n');
                        }
                        that.enterGoodCode = code;
                        that.getPartOtherDatas(that.partData.EntpTempGoodsId);
                        that.getWatermarkText();      
    
                    }
                })
                .catch(() => {})
                .finally(() => {
                    that.loading = false;
                });
        },
        getPartOtherDatas(partId) {
            if (partId) {
                this.$util
                    .axiosGet({
                        url: '/api/EntpGoods/GetPartOtherDatas',
                        data: {
                            EntpTempGoodsId: partId
                        },
                        hideLoading: true
                    })
                    .then(res => {
                        if (res.data) {
                            let data = res.data;
                            this.uploadPictureList = data.PictureList;

                            this.partData.GoodsSeriesRs = data.GoodsSeriesRs;
                            this.partData.AllModels = data.AllModels;

                            this.getAutoSeriesByApCode('edit', data.GoodsSeriesRs).then(() => {
                                this.partData.AllModels = data.AllModels;
                                if (data.AllModels) this.dialogCheckList = data.GoodsSeriesRs;
                            });
                        }
                    })
                    .catch(() => {})
                    .finally(() => {
                        this.loading = false;
                    });
            }
        },
        // 提交表单按钮
        submitConfirm() {
            let that = this;
            that.$refs.partData.validate(valid => {
                if (valid) {
                    this.saveBtndisabled = true;

                    that.partData.PackageSize = that.partData.Length + '*' + that.partData.Width + '*' + that.partData.Height;

                    that.partData.PictureList = [];
                    if (that.uploadPictureList && that.uploadPictureList.length > 0) {
                        that.uploadPictureList = Array.from(new Set(that.uploadPictureList));
                        that.partData.PictureList = that.uploadPictureList;
                    }
                    // 提交时插入数据
                    that.partData.GoodsSeriesRs = [];
                    if (that.dialogCheckList.length > 0 || that.brainCheckList.length > 0) {
                        that.partData.GoodsSeriesRs = [...that.dialogCheckList, ...that.brainCheckList];
                    }
                    that.partData.GoodCode = '';
                    if (that.enterGoodCode) {
                        let code = that.enterGoodCode;
                        if (code.indexOf('\n') !== -1) {
                            code = code.split('\n').join(',');
                        }
                        that.partData.GoodCode = code;
                    }
                    that.submitData();
                }
            });
        },
        // 提交表单事件
        submitData() {
            this.loading = true;
            let that = this;
            let type = 2;
            let title = '';

            let url = '/api/EntpGoods/SaveEnterprisePart_ecVs';
            if (that.partData.EntpTempGoodsId) type = 1;

            if (url) {
                that.$util
                    .axiosPost({
                        url: url,
                        data: that.partData,
                        hideLoading: true
                    })
                    .then(response => {
                        that.loading = false;
                        switch (type) {
                            case 1:
                                title = '编辑商品成功！';
                                break;
                            case 2:
                                title = '添加为商品成功！';
                                break;
                        }
                        //返回的商品id
                        that.partData.EntpTempGoodsId = response.data;

                        that.$util.successMsg(title);
                        that.needConfirm = false;
                        setTimeout(() => {
                            that.$store.commit('updateNeedRefresh', true);
                            window.history.go(-1);
                        }, 100);
                    })
                    .catch(() => {
                        that.loading = false;
                        that.saveBtndisabled = false;
                    });
            }
        },
        resetForm() {
            this.$refs.uploadMainFile.clearData();
            this.$refs.uploadMinorFile.clearData();
            this.partData = {};
        },
        showStoreDialog() {
            this.storeVisible = true;
        },
        closeStoreDialog() {
            this.storeVisible = false;
            // 关闭弹窗
            setTimeout(() => {
                this.needConfirm = false;
                this.$store.commit('updateNeedRefresh', true);
                window.history.go(-1);
            }, 100);
        },
        //匹配单位
        searchUnit(queryString, cb) {
            if (this.unitList && this.unitList.length > 0) {
                let list = this.unitList;
                this.querySearchAsync(list, queryString, cb);
            } else {
                this.getConfigData(cb);
            }
        },
        //匹配品牌
        searchBrand(queryString, cb) {
            if (this.brandList && this.brandList.length > 0) {
                let list = this.brandList;
                this.querySearchAsync(list, queryString, cb);
            } else {
                this.getEnterprisePartBrandList(cb);
            }
        },
        //获取品牌分类
        getEnterprisePartBrandList(cb) {
            this.$util.searchGoodsBrand().then(res => {
                this.brandList = res;
                if (cb) {
                    cb(this.brandList);
                }
            });
        },
        onAutoSeriseSelected(item) {
            this.partData.AutoSerise = item.SeriesName;
        },
        // 搜索汽配分类
        searchCate(key) {
            if (![undefined].includes(key)) {
                this.cateForm.Page = 1;
                this.cateForm.stopLoad = false;
                this.cateForm.key = key;
                this.apCategoryList = [];
            }
            if (this.cateForm.stopLoad) return;
            this.$util
                .getEntpApCategoryList(this.cateForm.key, this.cateForm.Page, this.cateForm.Limit)
                .then(data => {
                    if (!data) return;
                    this.cateForm.stopLoad = data.length < this.cateForm.Limit;
                    this.apCategoryList = [...this.apCategoryList, ...data];
                })
                .catch(() => {});
        },
        // 客户名称列表，加载更多
        searchCateLoad() {
            this.cateForm.Page += 1;
            this.searchCate();
        },
        cateVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.apCategoryList.length == 0) that.searchCate('');
            } else {
                if (!that.partData.ExAttribute1) {
                    that.partData.ExAttribute1 = that.cateForm.key;
                }
            }
        },
        cateClearHandle() {
            this.cateForm.key = '';
        },
        querySearchAsync(list, queryString, cb) {
            let results = queryString ? list.filter(this.createStateFilter(queryString)) : list;
            cb(results);
        },
        createStateFilter(queryString) {
            return item => {
                if (item) {
                    let reg = new RegExp(queryString);
                    return reg.test(item.Text);
                }
            };
        },
        //获取单位
        getConfigData(cb) {
            this.$util.searchGoodsUnit().then(res => {
                this.unitList = res;
                if (cb) {
                    cb(this.unitList);
                }
            });
        },
        // 上传主图片成功后执行
        uploadMainSuccess(res) {
            this.partData.MainImg = res;
        },
        // 删除主图片
        handleMainRemove(file) {
            this.partData.MainImg = '';
        },
        // 上传辅助图片成功后执行
        uploadMinorSuccess(res) {
            this.uploadPictureList.push(res);
        },
        // 删除辅助图片
        handleMinorRemove(file) {
            let fileUrl = file;
            let _pictureList = this.uploadPictureList;
            for (let i = 0; i < _pictureList.length; i++) {
                if (_pictureList[i] == fileUrl) {
                    _pictureList.splice(i, 1);
                }
            }
        },
        inputBlur(event) {
            if (!event.target.value) event.target.value = 0;
        },
        inputFocus(event) {
            if (event.target.value == 0) event.target.value = '';
        },
        // 校验编码是否重复
        checkAPCode() {
            let that = this;
            return new Promise((resolve, reject) => {
                if (that.isCheckCode) {
                    that.$util
                        .axiosGet({
                            url: '/api/EntpGoods/ValidateEnterprisePartCode',
                            data: {
                                APCode: that.partData.APCode
                            },
                            hideLoading: true
                        })
                        .then(res => {
                            if (res.data) {
                                resolve(); // 重复了
                            } else {
                                //新增库存时才匹配基础配件
                                if (that.partData.EntpTempGoodsId == '') {
                                    that.getAutoPartsByCodeOrId({
                                        Code: that.partData.APCode,
                                        Id: '',
                                        ShowLoading: false
                                    });
                                }
                                reject();
                            }
                        })
                        .catch(error => {
                            reject();
                        });
                } else {
                    reject();
                }
            });
        },
        // 选择车型
        selectCarType() {
            this.dialogVisible = true;
        },
        // 获取智能匹配车型
        async getAutoSeriesByApCode(type, row) {
            this.getWatermarkText();
            const {
                errcode,
                data: { Brands, Series }
            } = await this.$util.axiosPost({
                url: `/api/EntpGoods/GetAutoSeriesByApCode`,
                data: {
                    code: this.partData.APCode
                },
                hideLoading: true
            });
            if (errcode !== 0) {
                this.dialogCheckList = row;
                return;
            }
            if (Brands && Brands.length > 0) {
                // 处理下拉框展示数据
                this.checkSelectOptions = Brands.map(m => {
                    this.checkedAllList[m.BrandId] = [];
                    return {
                        isAllCheck: false,
                        ...m
                    };
                });
                // 当前下拉列表匹配关键字
                this.checkedSelect = this.checkSelectOptions[0].BrandId;
                // 处理智能匹配列表展示的数据
                this.checkCurrentOptions = Series.filter(item => {
                    return item.BrandId === this.checkedSelect;
                });
                this.checkAllOptions = Series;
            } else {
                this.checkedSelect = '';
                this.checkedAllList = {};
                this.checkSelectOptions = [];
                this.checkCurrentOptions = [];
                this.checkAllOptions = [];
            }
            // 处理编辑时展示的数据
            if (type === 'edit') {
                row.forEach(rEle => {
                    let sIndex = Series.findIndex(f => f.AutoSerieId === rEle.AutoSerieId);
                    if (~sIndex) {
                        rEle.BrandId === this.checkedSelect && this.checkedCurrentList.push(Series[sIndex]);
                        this.checkedAllList[rEle.BrandId].push(Series[sIndex]);
                    } else {
                        this.dialogCheckList.push(rEle);
                    }
                });
                if (this.checkSelectOptions.length > 0) this.checkSelectOptions[0].isAllCheck = this.checkedCurrentList.length === this.checkCurrentOptions.length;
                this.noopsycheDataHandle();
            }
        },
        // 删除添加的车型
        deleteCarTypeActive(type, index, row) {
            if (row.ModelDesc == '全车型') this.partData.AllModels = false;
            if (type === 1) {
                // this.dialogClearOptions.push(row);
                this.dialogCheckList.splice(index, 1);
            }
            if (type === 2) {
                if (this.checkedAllList && this.checkedAllList[row.BrandId]) {
                    let checkIndex = this.checkedAllList[row.BrandId].findIndex(i => i.AutoSerieId === row.AutoSerieId);
                    this.checkedAllList[row.BrandId].splice(checkIndex, 1);
                }

                this.noopsycheDataHandle();
                let ctIndex = this.checkSelectOptions.findIndex(f => f.BrandId === row.BrandId);
                if (ctIndex > -1) {
                    if (this.checkSelectOptions[ctIndex].isAllCheck) {
                        this.checkSelectOptions[ctIndex].isAllCheck = false;
                    }
                }

                let singleIndex = this.checkedCurrentList.findIndex(f => f.AutoSerieId === row.AutoSerieId);
                if (singleIndex > -1) this.checkedCurrentList.splice(singleIndex, 1);
            }
        },
        // 处理智能车型展示列表
        noopsycheDataHandle() {
            if (this.partData.AllModels) {
                this.partData.AllModels = false;
                this.dialogCheckList = [];
            }
            let values = Object.values(this.checkedAllList);
            if (values) {
                var arr = values.reduce((p, r) => [...p, ...r], []);
                var newArr = [];
                arr.forEach(e => {
                    let index = this.dialogCheckList.findIndex(i => {
                        return i.AutoSerieId === e.AutoSerieId;
                    });
                    if (!~index) newArr.push(e);
                });
                this.brainCheckList = newArr;
            }
        },
        // 把选中数据，去重后插入选择的车型列表中
        //与匹配互换码共用
        confirmSeriesButton(row) {
            if (this.partData.AllModels) {
                this.partData.AllModels = false;
                this.dialogCheckList = [];
            }

            let newChecks = [];
            if (this.dialogCheckList.length > 0) {
                for (let i = 0; i < this.dialogCheckList.length; i++) {
                    const element = this.dialogCheckList[i];

                    let index = row.findIndex(f => {
                        return f[4].split('{$}')[0] === element.AutoSerieId;
                    });

                    if (index > -1) newChecks.push(element);
                }
                this.dialogCheckList = newChecks;
            }

            row.forEach(ele => {
                let item = ele;
                //EngineType==undefined的是车型选择的操作，反之是通过发动机选择的
                if (this.dialogVisible && item.EngineType == undefined) {
                    item = {
                        AutoSerieId: ele[4].split('{$}')[0],
                        ModelDesc: ele[4].split('{$}')[1]
                    };
                }
                let index = this.dialogCheckList.findIndex(i => {
                    return i.AutoSerieId === item.AutoSerieId;
                });
                if (!~index) {
                    index = this.brainCheckList.findIndex(i => {
                        return i.AutoSerieId === item.AutoSerieId;
                    });
                    if (!~index) {
                        this.dialogCheckList.push(item);
                    }
                }
            });

            this.dialogVisible = false;
        },
        handlePaste(e) {
            let clip = e.clipboardData.getData('Text');
            if (clip) {
                let newVal = clip.replace(/\s*/g, '').replace(/,/g, '\n').replace(/，/g, ',');
                this.enterGoodCode = this.enterGoodCode + newVal.split(',').join('\n');
            }
        },
        searchGoodName(key, cb) {
            this.$util.searchPartAttr(key, 1, 1, 10).then(data => {
                let arr = [];
                if (data) {
                    data.forEach(e => {
                        arr.push({ value: e });
                    });
                }
                this.goodNameOptions = arr;
                if (cb) {
                    cb(this.goodNameOptions);
                }
            });
        },
        searchAutoSerise(key, cb) {
            this.$util.searchPartAttr(key, 2, 1, 10).then(data => {
                let arr = [];
                if (data) {
                    data.forEach(e => {
                        arr.push({ value: e });
                    });
                }
                this.autoSeriseOptions = arr;
                if (cb) {
                    cb(this.autoSeriseOptions);
                }
            });
        },
        getWatermarkText() {
            var watermarkText = '';
            let that = this;
            if (that.sptpsy) {
                if (that.partData.APCode != '') {
                    watermarkText = '编码：' + that.partData.APCode;
                }
                if (that.enterGoodCode != '') {
                    let gcode = that.enterGoodCode;
                    if (gcode.indexOf('\n') !== -1) {
                        gcode = gcode.split('\n')[0];
                    }
                    watermarkText += ';' + 'O  E：' + gcode;
                }
                if (that.partData.AutoSerise != '') {
                    let autos = that.partData.AutoSerise;
                    if (autos && autos.Length > 50) autos = autos.substring(0, 50);
                    watermarkText += ';' + '车型：' + autos;
                }
            }
            this.watermarkText = watermarkText;
            this.$refs.uploadMainFile.getWatermarkText(watermarkText);
            this.$refs.uploadMinorFile.getWatermarkText(watermarkText);
        },
    }
};
</script>

<style lang="less">
.price-point {
    .el-form-item {
        margin-bottom: 10px !important;
    }
}

.add-accessories {
    .form-line .form-item .el-form-item__label {
        white-space: nowrap;
    }

    .el-form-item {
        margin-bottom: 16px;
    }

    .section .middle textarea {
        height: 100%;
    }

    .packageSize {
        input {
            outline: none;
            height: 36px;
            line-height: 36px;
            border-radius: 5px;
            border: none;
            border: 1px solid #dcdfe6;
            text-align: center;
            width: 100px;
        }

        input:disabled {
            color: #c0c4cc;
            cursor: not-allowed;
            background-color: #f5f7fa;
        }
    }

    .dialog-s-content {
        .dialog-cascader-panel,
        .el-cascader-menu__wrap {
            height: 100%;
        }

        .el-cascader-menu__wrap {
            width: 186px;
        }

        .el-cascader-node__label {
            padding-right: 0;
        }
    }

    .row-body {
        .el-checkbox-group {
            .checkbox-item {
                display: flex;
                align-items: center;

                .el-checkbox__input {
                    margin-top: 2px;
                }
            }
        }

        .el-checkbox__label {
            white-space: normal;
        }
    }

    .cate-select {
        .el-input {
            .el-input__inner {
                height: 36px;
                line-height: 36px;
            }
        }
    }
}
</style>

<style lang="less" scoped>
.business-content-main {
    display: flex;
    flex-direction: column;
    height: 100%;

    .btns {
        // text-align: right;
        padding: 4px;
    }
}

.section {
    // flex: 1;
    // max-height: 85%;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;

    > div {
        height: 100%;
    }

    .all {
        width: 90%;
    }

    .middle {
        width: 15%;
        padding: 0 24px;
        margin: 0 24px;
        border-left: 1px solid #dedede;
        border-right: 1px solid #dedede;
        display: flex;
        flex-direction: column;

        .title {
            padding: 16px 0;
        }

        .input-textarea {
            flex: 1;
        }
    }
}

.form-main {
    margin-top: 5px;
    width: 100%;
    display: flex;
    flex-direction: column;

    .form-line {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
    }

    .form-item {
        width: 300px;

        .el-input {
            width: 200px;
        }

        .el-select {
            width: 200px;
        }
    }

    .form-item-remark {
        textarea {
            height: 100px;
        }

        .el-textarea {
            height: 100px;
        }

        .el-textarea__inner {
            height: 100px;
        }
    }
}

.autocomplete {
    li {
        line-height: normal;
        padding: 7px;

        .name {
            text-overflow: ellipsis;
            overflow: hidden;
        }

        .addr {
            font-size: 12px;
            color: #b4b4b4;
        }

        .highlighted .addr {
            color: #ddd;
        }
    }
}

.invTip {
    font-size: 12px;
    display: inline-block;
    position: absolute;
    top: 28px;
    left: 0;
    color: red;
}

.calc-btn {
    margin-left: 5px;
}
</style>
